/**
 * Extract hashtags (e.g. "#Expertise") from a raw text string.
 *
 * Returns hashtags in the user's original casing, deduplicated case-insensitively
 * (so "#Foo" and "#foo" collapse to a single entry — the first one wins).
 * Used to forward user-provided hashtags from `rawThought` into `/api/generate`,
 * which guarantees they appear in the LinkedIn post output.
 */
export function extractHashtags(text: string | null | undefined): string[] {
  if (!text) return [];
  const matches = text.match(/#\w+/g) ?? [];
  const seen = new Set<string>();
  const tags: string[] = [];
  for (const t of matches) {
    const k = t.toLowerCase();
    if (!seen.has(k)) {
      seen.add(k);
      tags.push(t);
    }
  }
  return tags;
}
